__webpack_require__.p = "/case-study/";